import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService,} from '../../_services/index';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ValidateUrl} from "../../helpers/url.validator";

@Component({
    standalone: false,
    selector: 'add-url-component',
    templateUrl: 'add-url.component.html'
})

export class AddUrlComponent implements OnInit {
  quizForm:FormGroup;
  url:string = '';

    constructor(
      formBuilder: FormBuilder,
      public dialogRef: MatDialogRef<AddUrlComponent>,
      public projectService: ProjectService,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public router: Router,
      public clientProfileService: ClientProfileService,
      public route: ActivatedRoute,
      public alertService: AlertService,
      public authenticationService: AuthenticationService) {
      this.quizForm = formBuilder.group({
    url: ['', [Validators.required, ValidateUrl]]
  });
    }

      ngOnInit() {
      }

    generate(): void{
      if (!this.quizForm.valid) return;
      this.dialogRef.close({url: this.quizForm.value.url});
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
